import React, { useRef, useEffect } from 'react';
import WebMap from '@arcgis/core/WebMap';
import MapView from '@arcgis/core/views/MapView';
import Extent from '@arcgis/core/geometry/Extent';

const mapDivStyle = {
  width: '100%',
  height: 600,
};

const INITIAL_EXTENT = new Extent({
  xmin: -97.0768,
  ymax: 28.9065,
  xmax: -96.8847,
  ymin: 28.7521,
  spatialReference: { wkid: 4326, latestWkid: 4326 },
});

export default function MyMapView({ location, graphics }) {
  const mapDiv = useRef(null);

  useEffect(() => {
    let mapView;

    if (mapDiv.current) {
      const webMap = new WebMap({
        portalItem: {
          id: '4a66f3f05a3542058dcb76d8ddd2ce67',
        },
      });
      mapView = new MapView({
        map: webMap,
        container: mapDiv.current,
        extent: INITIAL_EXTENT,
      });
      mapView.on('click', (event) => {
        event.stopPropagation();
        mapView.popup.open({
          features: graphics,
          location: event.mapPoint,
        });
      });
    }

    console.log('location:', location);
    if (location?.location?.x) {
      console.log('zooming to location');
      const x = location.location.x;
      const y = location.location.y;
      mapView
        .goTo({
          center: [x, y],
          zoom: 12,
        })
        .then(() => {
          mapView.popup.open({
            title: location.address,
            location: {
              latitude: y,
              longitude: x,
            },
          });
        });
    }

    mapView.graphics.removeAll();
    if (graphics.length > 0) {
      mapView.graphics.addMany(graphics);
    }
  }, [location, graphics]);

  return <div style={mapDivStyle} ref={mapDiv}></div>;
}
